// extracted by mini-css-extract-plugin
export default {"item":"styles_item__Kczb6","inner":"styles_inner__tvbWj","icon":"styles_icon__fPYOB","label":"styles_label__Kegh4"};